// utils.js (o helpers.js)
import moment from 'moment';

//ritorna status e colorstatus
export const getStatus = (data_inizio, data_fine) => {
  const currentDate = moment(); // Ottieni la data corrente
  const startDate = moment(data_inizio);
  const endDate = moment(data_fine);

  if (currentDate.isBetween(startDate, endDate)) {
    return { text: 'IN CORSO', color: '#F84A33' }; 
  } else if (currentDate.isBefore(startDate)) {
    const diff = startDate.diff(currentDate); // Calcola la differenza di tempo in millisecondi
    const duration = moment.duration(diff); // Ottieni la durata
    const hours = duration.hours(); // Ore rimanenti
    const minutes = duration.minutes(); // Minuti rimanenti

    if (hours > 0) {
      return { text: `TRA ${hours} ORE E ${minutes} MINUTI`, color:'#FFCC00'};
    } else {
      return { text: `TRA ${minutes} MINUTI`, color:'#FFCC00'};
    }
  } else {
    return {text: 'EVENTO FINITO', color: '#962309'}; // Non c'è tempo rimanente
  }
};
